<template>
    <NumInput 
        v-if="item.type == 1"
        v-model="itemValue" 
        clearable
        :suffix="item.data.unit != null ? item.data.unit : ''"
        :label="item.name" 
        outlined
        hide-details 
        type="text" 
        dense
        :canEdit="!readonly"
        align="align-left" />
    <v-text-field
        v-else-if="item.type == 2"
        v-model="itemValue" 
        clearable
        :label="item.name" 
        outlined
        :readonly="readonly"
        hide-details 
        type="text" 
        dense />
    <DatePicker 
        v-else-if="item.type == 3"                                                    
        :label="item.name"
        dense
        :canEdit="!readonly"
        v-model="itemValue" />
    <div v-else-if="item.type == 4" style="position:relative">
        <label v-if="itemValue != null && itemValue != ''" style="position:absolute; top:-10px; left:10px; z-index:999; font-size:12px; background-color:white">
            {{item.name}}
        </label>
        <VueCtkDateTimePicker
            v-model="itemValue"
            onlyTime
            minuteInterval="30"
            format="HH:mm"
            formatted="HH:mm"
            :label="item.name"
            noHeader
            noButton
            noLabel />
    </div> 
    <!-- <VueCtkDateTimePicker
        v-else-if="item.type == 4"
        v-model="itemValue"
        onlyTime
        minuteInterval="30"
        format="HH:mm"
        formatted="HH:mm"
        :label="item.name"
        noHeader
        noButton /> -->
    <CategoryItemSelector
        v-else-if="item.type == 7"
        :label="item.name"
        dense
        hide-details
        :canEdit="!readonly"
        :items="composts"
        v-model="itemValue" />
    <CategoryItemSelector
        v-else-if="item.type == 8"
        :label="item.name"
        dense
        hide-details 
        :canEdit="!readonly"
        :items="fertilizeries"
        v-model="itemValue" />
    <CategoryItemSelector
        v-else-if="item.type == 9"
        :label="item.name"
        dense
        hide-details 
        :canEdit="!readonly"
        :items="pesticides"
        v-model="itemValue" />
    <AgrichemicalSetter
        v-else-if="item.type == 10"
        v-model="itemValue"
        :canEdit="!readonly"
        :workDate="workDate"
        :targetPlace="targetPlace"
        :isNewWorkRecord="isNewWorkRecord" />
    <ShipmentAndSales
        v-else-if="item.type == 11"
        v-model="itemValue"
        :canEdit="!readonly"
        :item="item" />
    <Sick
        v-else-if="item.type == 12"
        v-model="itemValue"
        :canEdit="!readonly"
        :item="item" />
    <Vermin
        v-else-if="item.type == 13"
        v-model="itemValue"
        :canEdit="!readonly"
        :item="item" />
</template>

<script>
    import CategoryItemSelector from '@/components/tools/CategoryItemSelector';
    import NumInput from '@/components/tools/SoftwareNumKeyboard'
    import DatePicker from '@/components/tools/DatePicker';
    import AgrichemicalSetter from '@/components/place/PlaceWorkRecorderAgrichemical';
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import ShipmentAndSales from '@/components/place/PlaceWorkRecorderShipmentAndSales';
    import Sick from '@/components/place/PlaceWorkRecorderSick';
    import Vermin from '@/components/place/PlaceWorkRecorderVermin';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

    export default {
        components: {
            CategoryItemSelector,
            NumInput,
            DatePicker,
            VueCtkDateTimePicker,
            AgrichemicalSetter,
            ShipmentAndSales,
            Sick,
            Vermin
        },
        props: {
            value: null,
            item: null,
            composts: null,
            fertilizeries: null,
            pesticides: null,
            /** 読み取り専用とするか否か */
            readonly: {
                type: Boolean,
                default: false
            },
            /** 対象場所 */
            targetPlace: null,
            /** 作業日 */
            workDate: "",
            /** 新しい作業記録か否か */
            isNewWorkRecord: false
        },
        computed: {
            itemValue: {
                get: function () {
                    return this.$props.value
                },
                set: function (v) {
                    // console.log(v)
                    this.$emit("input", v)
                }
            },
            sicks: function () {
                return this.$store.getters["managementItems/sicksArray"]
            },
            vermins: function () {
                return this.$store.getters["managementItems/verminsArray"]
            }
        }
    }
</script>
